import { render, staticRenderFns } from "./data71.vue?vue&type=template&id=ed8a21f0&scoped=true"
import script from "./data71.vue?vue&type=script&lang=js"
export * from "./data71.vue?vue&type=script&lang=js"
import style1 from "./data71.vue?vue&type=style&index=1&id=ed8a21f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8a21f0",
  null
  
)

export default component.exports